import * as React from 'react';
import {compose} from 'redux';
import {useDataProvider} from '../../fetchApi/dataProvider';
import {FETCH} from '../../fetchApi/types';
import {
    endpointConnectToIntegration,
    integrationConnectionRedirectPathLocalStorageKey,
    resourceIntegrationCredentials,
    resourceIntegrations,
} from '../../constants';
import {RouteChildrenProps, withRouter} from 'react-router-dom';
import {NotificationManager} from 'react-notifications';
import {useTranslation} from 'react-i18next';
import Callback from '../Callback/CallbackSpinner';

interface IntegrationCallbackProps {
    provider: string;
}

const CallbackView: React.FunctionComponent<IntegrationCallbackProps & RouteChildrenProps> = ({
    history,
    provider
}) => {
    const {dataProvider} = useDataProvider();
    const {t: translate} = useTranslation();

    React.useEffect(() => {
        const callbackUrl = location.href;
        dataProvider(
            FETCH,
            `${resourceIntegrationCredentials}/${endpointConnectToIntegration}`,
            {provider, callbackUrl}
        )
            .then(() => {
                NotificationManager.success(
                    translate('integrations.notifications.connect',
                        {context: 'success'},
                    ),
                );

                let redirectPath = `/${resourceIntegrations}`;
                const localStorageRedirectPath = localStorage.getItem(integrationConnectionRedirectPathLocalStorageKey);
                if (localStorageRedirectPath) {
                    redirectPath = localStorageRedirectPath;
                    localStorage.removeItem(integrationConnectionRedirectPathLocalStorageKey);
                }

                history.push(redirectPath);
            })
            .catch((e) => {
                NotificationManager.error(
                    e.message,
                    translate(
                        'integrations.notifications.connect',
                        {context: 'fail'},
                    ),
                );
                history.push(`/${resourceIntegrations}`);
            });
    }, []);

    return (
        <Callback />
    );
};

// @ts-ignore
const IntegrationCallback: React.FunctionComponent<IntegrationCallbackProps> = compose(
    withRouter,
    // @ts-ignore
)(CallbackView);

export default IntegrationCallback;